var _path, _mask, _g, _mask2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5231 7.6H17.7693C18.1769 7.6 18.5077 7.26917 18.5077 6.86154C18.5077 6.45391 18.1769 6.12308 17.7693 6.12308H13.5231C13.1155 6.12308 12.7847 6.45391 12.7847 6.86154C12.7847 7.26917 13.1155 7.6 13.5231 7.6Z",
    fill: "#20123A"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 12,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4.64651H16.3849V16.0306H5V4.64651Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9079 10.3386C14.9065 11.5689 14.453 12.6086 13.7087 13.3545C12.9628 14.0988 11.9231 14.5522 10.6928 14.5537C9.46179 14.5522 8.42203 14.0988 7.67619 13.3545C6.93182 12.6086 6.4784 11.5689 6.47693 10.3386C6.4784 9.10831 6.93182 8.06855 7.67619 7.32197C8.42203 6.57834 9.46179 6.12492 10.6928 6.12344C11.1004 6.12344 11.4313 5.79261 11.4313 5.38498C11.4313 4.97661 11.1004 4.64652 10.6928 4.64652C9.09182 4.64431 7.65477 5.2528 6.63126 6.27778C5.60628 7.30129 4.99853 8.73834 5 10.3386C4.99853 11.9388 5.60628 13.3759 6.63126 14.3994C7.65477 15.4244 9.09182 16.0321 10.6928 16.0306C12.293 16.0321 13.7301 15.4244 14.7536 14.3994C15.7786 13.3759 16.3863 11.9388 16.3849 10.3386C16.3849 9.93095 16.054 9.60012 15.6464 9.60012C15.2388 9.60012 14.9079 9.93095 14.9079 10.3386Z",
    fill: "#20123A"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 7,
    height: 6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4922 13.1383H19.2154V18.8615H13.4922V13.1383Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7087 14.399L17.9549 18.6452C18.2436 18.9339 18.7103 18.9339 18.9991 18.6452C19.2878 18.3564 19.2878 17.8897 18.9991 17.601L14.7529 13.3548C14.4642 13.0661 13.9975 13.0661 13.7087 13.3548C13.42 13.6436 13.42 14.1103 13.7087 14.399Z",
    fill: "#20123A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.08213bbb.svg";
export { ForwardRef as ReactComponent };